"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IllustrationText = exports.CreateOfferButton = exports.ButtonsWrapper = exports.TabTitle = exports.StyledCheckList = void 0;
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
const streamline_icon_employee_checklist_4_svg_1 = __importDefault(require("@public/media/illustrations/streamline-icon-employee-checklist-4.svg"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCheckList = (0, styled_components_1.default)(streamline_icon_employee_checklist_4_svg_1.default) `
	opacity: 50%;
	margin-bottom: 1.5rem;
	width: 100%;
`;
exports.TabTitle = styled_components_1.default.span `
	padding-right: 2rem;
`;
exports.ButtonsWrapper = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;

	${(0, styled_breakpoints_1.down)('sm')} {
		flex-direction: column;
	}
`;
exports.CreateOfferButton = (0, styled_components_1.default)(elements_1.Button) `
	margin-right: 1rem;

	${(0, styled_breakpoints_1.down)('sm')} {
		margin-right: 0;
		margin-bottom: 1rem;
	}
`;
exports.IllustrationText = styled_components_1.default.div `
	font-size: 16px;
	font-weight: bold;
	color: ${({ theme }) => theme.color.brand3};
	text-align: center;
`;
